module.exports = __webpack_public_path__ + "img/toggle.0cb524ca.svg";